<template>
  <div id="app" @keydown.esc="closeDialog()">
    <v-app id="runner" class="added-value">
      <router-view></router-view>
      <v-snackbar v-model="snackbar" app top color="info">
        <div class="d-flex align-center">
          {{ snackbarText }}
          <v-spacer></v-spacer>
          <v-btn icon @click="snackbar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-snackbar>
      <v-dialog v-model="appBanner.active" max-width="500">
        <v-card>
          <v-card-title>
            {{ appBanner.title }}
          </v-card-title>
          <v-card-text>
            {{ appBanner.content }}
          </v-card-text>
          <v-card-actions>
            <v-btn @click="appBanner.active = false">סגור</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <long-action-modal ref="longActionModal"></long-action-modal>
    </v-app>
  </div>
</template>

<script>
import LongActionModal from "./components/LongActionModal.vue";

export default {
  name: "App",
  components: { LongActionModal },
  data: () => ({
    snackbar: false,
    snackbarText: "",
    appBanner: {
      active: false,
      title: "",
      content: ""
    },
    bannerLoaded: false
  }),
  computed: {
    isUserView() {
      return this.$route.path.startsWith("/my");
    }
  },
  watch: {
    isUserView(newVal) {
      if (newVal) {
        this.loadAppBanner();
      }
    }
  },
  methods: {
    closeDialog() {
      this.$actions.closeDialog();
    },
    loadAppBanner() {
      if (this.$account.auth && this.isUserView && !this.bannerLoaded) {
        this.$actions.loadAppBanner().then((banner) => {
          this.appBanner = banner;
          this.bannerLoaded = true;
        });
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$store.setLongActionModalRef(this.$refs.longActionModal);
    });

    this.$bus.$on("showSnackbar", (text) => {
      this.snackbarText = text;
      this.snackbar = true;
    });

    this.$bus.$on("authenticated", () => {
      this.loadAppBanner();
    });

    this.$bus.$on("showAppBanner", (banner) => {
      this.appBanner = banner;
    });
  }
};
</script>

<style lang="stylus">
* {
  box-sizing: border-box;
}

.v-application.added-value {
  font-family: 'Open Sans', san-serif !important;
  .title, .subtitle-1, .caption { 
    font-family: 'Open Sans', san-serif !important;
  }
}

/* this is a vue bug that put overflow-y: scroll for some reason */
html {
  overflow-y: auto !important;
}

.ltr {
  direction: ltr;
}

.ltr-field input {
  direction: ltr;
  text-align: right;
}

.rtl {
  direction: rtl;
}

/* hide grecaptcha as it only been used for login */
.grecaptcha-badge {
  visibility: hidden;
}

.gap-xs {
  gap: 5px;
}

.gap-sm {
  gap: 10px;
}

.gap-md {
  gap: 15px;
}

/* rich html content formats */
.rich-html {
  p {
    margin-bottom: 0px !important;
  }

  ol, ul {
    padding-right: 24px !important;
  }

  Li:before {
    padding-left: 0px !important;
  }

  blockquote {
    border-left: none !important;
    background: #f5f5f5;
    /* border-radius: 4px; */
    padding-left: 10px !important;
    padding-right: 10px !important;
    border-right: 4px solid #ccc;
    margin: 0px !important;
    margin-top: 5px !important;
    padding-top: 5px !important;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  blockquote + blockquote {
    border-radius: 0px;
    padding-top: 0px !important;
    margin: 0px !important;
  }

  blockquote:last-of-type, blockquote:has(+ :not(blockquote)) {
    padding-bottom: 5px !important;
    margin-bottom: 5px !important;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}

.rich-html.short {
  max-height: 128px;
  overflow: auto;
}

/* cards colors */
.dashboard-card-color.color-blue {
  background: rgb(236, 242, 255) !important;

  .text-color, .v-icon {
    color: rgb(93, 135, 255) !important;
  }
}

.dashboard-card-color.color-yellow {
  background: rgb(254, 245, 229) !important;

  .text-color, .v-icon {
    color:  rgb(255, 174, 31) !important;
  }
}

.dashboard-card-color.color-cyan {
  background: rgb(232, 247, 255) !important;

  .text-color, .v-icon {
    color: rgb(73, 190, 255) !important;
  }
}

.dashboard-card-color.color-red {
  background: rgb(253, 237, 232) !important;

  .text-color, .v-icon {
    color: rgb(250, 137, 107) !important;
  }
}


.dashboard-card-color.color-green {
  background: rgb(230, 255, 250) !important;

  .text-color, .v-icon {
    color: rgb(19, 222, 185) !important;
  }
}

/* cursor classes */ 
body.cursor-larger-black {
  .cursor-pointer {
    cursor: url("data:image/svg+xml;base64,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"), auto !important
  }

  .cursor-default {
    cursor: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgdmlld0JveD0iMCAwIDgwIDgwIj48cG9seWxpbmUgcG9pbnRzPSI1LjIgNC4yIDIuMiA0LjIgMjYuMyA2OS4zIDM4IDQ5IDY2IDc4IDc2LjcgNjcgNDkuMyAzNy43IDcwLjcgMjYuNyA1LjMgNSAiLz48cGF0aCBkPSJNNzkuMSA2NC4yTDUwLjEgMzUuMmMtMS4xLTEuMS0zLTEuMS00LjIgMCAtMS4xIDEuMS0xLjEgMyAwIDQuMmwyNi45IDI2LjggLTYuNiA2LjZMMzkuMyA0NmMtMC43LTAuNy0xLjctMS0yLjYtMC44IC0xIDAuMi0xLjggMC44LTIuMiAxLjdMMjYuOCA2My41IDcuNyA3LjdsNTYgMTkuMSAtNi4zIDNjLTEuNSAwLjctMi4xIDIuNS0xLjQgMy45IDAuNyAxLjUgMi41IDIuMSAzLjkgMS40bDEyLjktNi4xYzEuMS0wLjUgMS44LTEuNiAxLjctMi44IC0wLjEtMS4yLTAuOS0yLjItMi0yLjZMMy45IDAuMkMyLjgtMC4yIDEuNiAwLjEgMC45IDAuOSAwLjEgMS43LTAuMiAyLjggMC4yIDMuOUwyMy41IDcyLjRjMC40IDEuMSAxLjQgMS45IDIuNiAyIDEuMiAwLjEgMi4zLTAuNiAyLjgtMS43bDkuMS0xOS41IDI2IDI1LjlDNjQuNyA3OS43IDY1LjUgODAgNjYuMiA4MGMwLjggMCAxLjUtMC4zIDIuMS0wLjlsMTAuOC0xMC44Qzc5LjcgNjcuOCA4MCA2NyA4MCA2Ni4zIDgwIDY1LjUgNzkuNyA2NC43IDc5LjEgNjQuMnoiIGZpbGw9IiNEOEQ4RDgiLz48L3N2Zz4="), auto !important
  }
}

body.cursor-larger-white {
  .cursor-pointer {
    cursor: url("data:image/svg+xml;base64,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"), auto !important;
  }

  .cursor-default {
    cursor: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgdmlld0JveD0iMCAwIDgwIDgwIj48cG9seWxpbmUgcG9pbnRzPSI1IDQgMiA0IDI2IDY5IDM4IDQ5IDY2IDc4IDc3IDY3IDQ5IDM4IDcxIDI3IDUgNSAiIGZpbGw9IiNGRkYiLz48cGF0aCBkPSJNNzkgNjRMNTAgMzVjLTEtMS0zLTEtNCAwIC0xIDEtMSAzIDAgNGwyNyAyNyAtNyA3TDM5IDQ2Yy0xLTEtMi0xLTMtMSAtMSAwLTIgMS0yIDJMMjcgNjQgOCA4bDU2IDE5IC02IDNjLTEgMS0yIDItMSA0IDEgMSAyIDIgNCAxbDEzLTZjMS0xIDItMiAyLTMgMC0xLTEtMi0yLTNMNCAwQzMgMCAyIDAgMSAxIDAgMiAwIDMgMCA0TDI0IDcyYzAgMSAxIDIgMyAyIDEgMCAyLTEgMy0ybDktMTkgMjYgMjZDNjUgODAgNjUgODAgNjYgODBjMSAwIDIgMCAyLTFsMTEtMTFDODAgNjggODAgNjcgODAgNjYgODAgNjUgODAgNjUgNzkgNjR6IiBmaWxsPSIjMEQwRDBEIi8+PC9zdmc+"), auto !important;
  }
}

body:not(.cursor-larger-white,.cursor-larger-black) {
  .cursor-pointer {
    cursor: pointer;
  }
  .cursor-default {
    cursor: default;
  }
}

body.highlight-titles .card-title {
  font-weight: 900;
  background-color: #d4ff32 !important;
  border-radius: 4px;
  color: #08344c !important
}

</style>
